export const NotificationType = Object.freeze({
  app_new_version: 'NOTIFICATION_TYPE_APP_NEW_VERSION',
});
